import { render, staticRenderFns } from "./MMP_MainFeatureButtons.vue?vue&type=template&id=79dbc6e9&scoped=true&"
import script from "./MMP_MainFeatureButtons.vue?vue&type=script&lang=js&"
export * from "./MMP_MainFeatureButtons.vue?vue&type=script&lang=js&"
import style0 from "./MMP_MainFeatureButtons.vue?vue&type=style&index=0&id=79dbc6e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dbc6e9",
  null
  
)

export default component.exports